import React, { useState } from 'react';
import { Users, Settings, Landmark, Database } from 'lucide-react';
import PageLayout from 'components/common/PageLayout';
import ConfiguracoesUsuarios from 'features/configuracoes/components/ConfiguracoesUsuarios';
import ConfiguracoesPresets from 'features/configuracoes/components/ConfiguracoesPresets';
import BankCredentials from 'features/administrativo/components/BankCredentials';
import IxcSources from 'features/configuracoes/components/IxcSources';
import { usePermissions } from 'hooks/usePermissions';

const ConfiguracoesPage = () => {
  const { hasPermission } = usePermissions();
  const [abaAtiva, setAbaAtiva] = useState('usuarios');

  const abas = [
    {
      id: 'usuarios',
      label: 'Usuários',
      icon: Users,
      description: 'Gerenciar usuários e permissões'
    },
    {
      id: 'presets',
      label: 'Presets',
      icon: Settings,
      description: 'Configurar presets de permissões'
    },
    {
      id: 'credenciais-bancarias',
      label: 'Credenciais Bancárias',
      icon: Landmark,
      description: 'Gerenciar credenciais e certificados bancários'
    },
    ...(hasPermission('config.ixc_sources.view') ? [{
      id: 'integracoes-ixc',
      label: 'Integrações IXC',
      icon: Database,
      description: 'Gerenciar conexões de leitura com o IXC'
    }] : [])
  ];

  const renderizarAba = () => {
    switch (abaAtiva) {
      case 'usuarios':
        return <ConfiguracoesUsuarios />;
      case 'presets':
        return <ConfiguracoesPresets />;
      case 'credenciais-bancarias':
        return <BankCredentials />;
      case 'integracoes-ixc':
        return <IxcSources />;
      default:
        return <ConfiguracoesUsuarios />;
    }
  };

  return (
    <PageLayout>
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        {/* Cabeçalho */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold" style={{ color: 'var(--text-primary)' }}>Configurações</h1>
          <p className="mt-2" style={{ color: 'var(--text-muted)' }}>
            Gerencie usuários, permissões e integrações do sistema
          </p>
        </div>

        {/* Navegação por Abas */}
        <div className="mb-5">
          <div className="border-b" style={{ borderColor: 'var(--border)' }}>
            <nav className="-mb-px flex gap-2 overflow-x-auto scrollbar-hide">
              {abas.map((aba) => {
                const Icon = aba.icon;
                const isActive = abaAtiva === aba.id;
                
                return (
                  <button
                    key={aba.id}
                    onClick={() => setAbaAtiva(aba.id)}
                    style={{
                      color: isActive ? 'var(--accent)' : 'var(--text-muted)',
                      borderColor: isActive ? 'var(--accent)' : 'transparent',
                      background: isActive ? 'var(--surface-muted)' : 'transparent'
                    }}
                    className={`group inline-flex shrink-0 whitespace-nowrap items-center py-2.5 px-3 border-b-2 rounded-t-lg font-medium text-sm transition-colors ${
                      isActive
                        ? ''
                        : 'hover:opacity-80'
                    }`}
                  >
                    <Icon
                      className={`w-5 h-5 mr-2 ${isActive ? '' : 'opacity-75 group-hover:opacity-100'}`}
                      style={{ color: isActive ? 'var(--accent)' : 'var(--text-muted)' }}
                    />
                    {aba.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Conteúdo da Aba Ativa */}
        <div className="mt-4">
          {renderizarAba()}
        </div>
      </div>
    </PageLayout>
  );
};

export default ConfiguracoesPage;
